module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('rt-section', {
    attrs: {
      "title": _vm.title,
      "icon": "rt-base-device"
    }
  }, [_c('el-upload', {
    ref: "upload",
    attrs: {
      "slot": "btn",
      "on-success": _vm.uploadSuccess,
      "on-error": _vm.uploadError,
      "on-change": _vm.fileChanged,
      "action": _vm.fileUploadUrl,
      "headers": _vm.config,
      "data": _vm.fileData,
      "name": _vm.fileName,
      "file-list": _vm.fileList,
      "show-file-list": false,
      "auto-upload": true,
      "multiple": ""
    },
    slot: "btn"
  }, [_c('rt-button-group', [_c('rt-button', {
    attrs: {
      "icon-name": "rt-base-plus_bold"
    }
  })], 1)], 1), _vm._v(" "), (_vm.fileList.length <= 0) ? _c('div', {
    staticClass: "empty-file"
  }, [_c('p', [_vm._v(_vm._s(_vm.$tx('暂时没有附件哦', 'xpc.attachment.novalue')))])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22e4afc2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/attachment/rtAttachment.vue
// module id = 1470
// module chunks = 91